export class AccountModel {
    constructor (public customerKey: number,
        public id: string) {
    }
}
